import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, NgZone, Input } from '@angular/core';

import { fromEvent } from 'rxjs';
import { map, startWith, distinctUntilChanged, shareReplay } from 'rxjs/operators';
import { MatLineSetter } from '@angular/material/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { LogService } from '../log.service';
import { ScrollService } from '../scroll.service';
import { SendEmailService, Contact } from '../send-email.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AutoHeightService } from 'ngx-owl-carousel-o/lib/services/autoheight.service';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  animations: [
    trigger('submitted', [
      // ...
      state('show', style({
        width: '100%',
        opacity: 1,
        overflow: 'hidden',
        height: 'auto',
      })),
      state('hidden', style({
        width: '0px',
        opacity: 0,
        overflow: 'hidden',
        height: 0
      })),
      transition('show => hidden', [
        animate('0.25s ease-out')
      ]),
      transition('hidden => show', [
        animate('0.3s ease-out')
      ]),
    ]),
  ],
})
export class FormComponent implements AfterViewInit {

  @Input() preText: string;
  @ViewChild('formBG', { static: true }) formBG: ElementRef;
  @ViewChild('recaptcha', {static: true }) recaptchaElement: ElementRef;

  contactForm = new FormGroup({
    name: new FormControl('', [
      Validators.required,
      Validators.minLength(2)]),
    surname: new FormControl('', [
      Validators.required,
      Validators.minLength(2)]),
    email: new FormControl('',
    Validators.required),
    phone: new FormControl('', [
    Validators.minLength(8), Validators.maxLength(12)]),
    mailText: new FormControl('...'), // workaround for label bug
    age: new FormControl(0),
  });

  public formSubmitted = false;

  public blockSubmit = true;
 
  public colors = { start: { R: 45, G: 141, B: 162 }, end: { R: 45, G: 141, B: 162 }}
  public color = this.colors.start;

  constructor(
    private zone: NgZone,
    private log: LogService,
    public scroll: ScrollService,
    public sendEmail: SendEmailService
     ) { }

  ngAfterViewInit() {
  /*  var divOffset = this.scroll.offsetTop(this.formBG.nativeElement);
    this.scroll.windowScroll$.subscribe(
      (res) => { 
      //  console.log(res+window.innerHeight,divOffset.top);
      //  console.log(divOffset.top, res);
     // console.log(res);
        if (res+window.innerHeight>divOffset.top && res+window.innerHeight <= divOffset.top + divOffset.height ) {
        this.color = this.updateBGcolor(this.reMap(res+window.innerHeight, divOffset.top, divOffset.top + divOffset.height, 0, 1)); // fade modifier, 0 to 1
        
      }  }
      ); */

      this.addRecaptchaScript();
      this.contactForm.patchValue({mailText: this.preText});
    // get abs scroll, height of element, mappa il colore da Yabs=0 a Yabs=height ed embeddalo in ngStyle
  //  console.log(divOffset.top, divOffset.height);
 //   const element = this.formBG.nativeElement;
  //  this.someInput.nativeElement.value = "Anchovies! 🍕🍕";
  }
  

  updateBGcolor(n) {
    console.log(n);
    let diffRed = this.colors.end.R - this.colors.start.R;
    let diffGreen = this.colors.end.G - this.colors.start.G;
    let diffBlue = this.colors.end.B - this.colors.start.B;

    diffRed = (diffRed * n) + this.colors.start.R;
    diffGreen = (diffGreen * n) + this.colors.start.G;
    diffBlue = (diffBlue * n) + this.colors.start.B;

    return {R: diffRed, G: diffGreen, B: diffBlue}

  }
  public reMap (from, fromMin, fromMax, toMin, toMax)
    {
        var fromAbs  =  from - fromMin;
        var fromMaxAbs = fromMax - fromMin;      
       
        var normal = fromAbs / fromMaxAbs;
 
        var toMaxAbs = toMax - toMin;
        var toAbs = toMaxAbs * normal;
 
        var to = toAbs + toMin;
        return to;
    }

    onSubmit() {
      const contact = new Contact();
      contact.name = this.contactForm.value.name;
      contact.surname = this.contactForm.value.surname;
      contact.email = this.contactForm.value.email;
      contact.phone = this.contactForm.value.phone;
      contact.text = this.contactForm.value.mailText;
      contact.type = "none";
      
      this.sendEmail.sendEmail(contact);
      this.formSubmitted = true;
    }

    addRecaptchaScript() {
 
      window['grecaptchaCallback'] = () => {
        this.renderReCaptcha();
      }
     
      (function(d, s, id, obj){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) { obj.renderReCaptcha(); return;}
        js = d.createElement(s); js.id = id;
        js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'recaptcha-jssdk', this));
     
    }

    renderReCaptcha() {
      window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
        'sitekey' : environment.captchaSiteKey,
        'callback': (response) => {
            console.log(response);
            this.zone.run( () => {
            this.blockSubmit = false;
            });
        }
      });
    }
  
}
